// College brand colors - primary and secondary
// Source: Official brand guides
export const COLLEGE_COLORS = {
  'Ohio State University': { primary: '#BB0000', secondary: '#666666', text: '#FFFFFF' },
  'University of Alabama': { primary: '#9E1B32', secondary: '#828A8F', text: '#FFFFFF' },
  'University of Michigan': { primary: '#00274C', secondary: '#FFCB05', text: '#FFCB05' },
  'Michigan State University': { primary: '#18453B', secondary: '#FFFFFF', text: '#FFFFFF' },
  'University of Georgia': { primary: '#BA0C2F', secondary: '#000000', text: '#FFFFFF' },
  'Clemson University': { primary: '#F56600', secondary: '#522D80', text: '#FFFFFF' },
  'LSU': { primary: '#461D7C', secondary: '#FDD023', text: '#FDD023' },
  'University of Texas': { primary: '#BF5700', secondary: '#FFFFFF', text: '#FFFFFF' },
  'University of Oregon': { primary: '#154733', secondary: '#FEE123', text: '#FEE123' },
  'Penn State University': { primary: '#041E42', secondary: '#FFFFFF', text: '#FFFFFF' },
  'University of Florida': { primary: '#0021A5', secondary: '#FA4616', text: '#FA4616' },
  'University of Tennessee': { primary: '#FF8200', secondary: '#FFFFFF', text: '#FFFFFF' },
  'University of Notre Dame': { primary: '#0C2340', secondary: '#C99700', text: '#C99700' },
  'University of Oklahoma': { primary: '#841617', secondary: '#FDF9D8', text: '#FFFFFF' },
  'USC': { primary: '#990000', secondary: '#FFC72C', text: '#FFC72C' },
  'University of Southern California': { primary: '#990000', secondary: '#FFC72C', text: '#FFC72C' },
  'UCLA': { primary: '#2D68C4', secondary: '#F2A900', text: '#F2A900' },
  'Stanford University': { primary: '#8C1515', secondary: '#FFFFFF', text: '#FFFFFF' },
  'University of Miami': { primary: '#F47321', secondary: '#005030', text: '#FFFFFF' },
  'Florida State University': { primary: '#782F40', secondary: '#CEB888', text: '#CEB888' },
  'Auburn University': { primary: '#0C2340', secondary: '#E87722', text: '#E87722' },
  'Texas A&M University': { primary: '#500000', secondary: '#FFFFFF', text: '#FFFFFF' },
  'University of Wisconsin': { primary: '#C5050C', secondary: '#FFFFFF', text: '#FFFFFF' },
  'University of Iowa': { primary: '#FFCD00', secondary: '#000000', text: '#000000' },
  'University of Nebraska': { primary: '#E41C38', secondary: '#F5F1E7', text: '#FFFFFF' },
  'University of Colorado': { primary: '#CFB87C', secondary: '#000000', text: '#000000' },
  'University of Arizona': { primary: '#CC0033', secondary: '#003366', text: '#FFFFFF' },
  'Arizona State University': { primary: '#8C1D40', secondary: '#FFC627', text: '#FFC627' },
  'University of Washington': { primary: '#4B2E83', secondary: '#B7A57A', text: '#B7A57A' },
  'Oregon State University': { primary: '#DC4405', secondary: '#000000', text: '#FFFFFF' },
  'University of Arkansas': { primary: '#9D2235', secondary: '#FFFFFF', text: '#FFFFFF' },
  'University of Kentucky': { primary: '#0033A0', secondary: '#FFFFFF', text: '#FFFFFF' },
  'University of South Carolina': { primary: '#73000A', secondary: '#000000', text: '#FFFFFF' },
  'Mississippi State University': { primary: '#660000', secondary: '#FFFFFF', text: '#FFFFFF' },
  'University of Mississippi': { primary: '#CE1126', secondary: '#14213D', text: '#FFFFFF' },
  'Purdue University': { primary: '#CEB888', secondary: '#000000', text: '#000000' },
  'Indiana University': { primary: '#990000', secondary: '#FFFFFF', text: '#FFFFFF' },
  'University of Minnesota': { primary: '#7A0019', secondary: '#FFCC33', text: '#FFCC33' },
  'Northwestern University': { primary: '#4E2A84', secondary: '#FFFFFF', text: '#FFFFFF' },
  'University of Pittsburgh': { primary: '#003594', secondary: '#FFB81C', text: '#FFB81C' },
  'West Virginia University': { primary: '#002855', secondary: '#EAAA00', text: '#EAAA00' },
  'Virginia Tech': { primary: '#630031', secondary: '#CF4420', text: '#CF4420' },
  'University of Virginia': { primary: '#232D4B', secondary: '#F84C1E', text: '#F84C1E' },
  'North Carolina State University': { primary: '#CC0000', secondary: '#000000', text: '#FFFFFF' },
  'University of North Carolina': { primary: '#7BAFD4', secondary: '#13294B', text: '#FFFFFF' },
  'Duke University': { primary: '#003087', secondary: '#FFFFFF', text: '#FFFFFF' },
  'Wake Forest University': { primary: '#9E7E38', secondary: '#000000', text: '#FFFFFF' },
  'Syracuse University': { primary: '#F76900', secondary: '#002060', text: '#FFFFFF' },
  'Boston College': { primary: '#98002E', secondary: '#BC9B6A', text: '#BC9B6A' },
  'University of Louisville': { primary: '#AD0000', secondary: '#000000', text: '#FFFFFF' },
  'University of Cincinnati': { primary: '#E00122', secondary: '#000000', text: '#FFFFFF' },
  'UCF': { primary: '#BA9B37', secondary: '#000000', text: '#000000' },
  'Baylor University': { primary: '#154734', secondary: '#FFB81C', text: '#FFB81C' },
  'TCU': { primary: '#4D1979', secondary: '#A3A9AC', text: '#FFFFFF' },
  'University of Houston': { primary: '#C8102E', secondary: '#FFFFFF', text: '#FFFFFF' },
  'Alabama A&M University': { primary: '#660000', secondary: '#FFFFFF', text: '#FFFFFF' },
  'William & Mary': { primary: '#115740', secondary: '#B9975B', text: '#B9975B' },
  'Southern University': { primary: '#0033A0', secondary: '#FFD200', text: '#FFD200' },
  'Jackson State University': { primary: '#00205B', secondary: '#FFFFFF', text: '#FFFFFF' },
  'Howard University': { primary: '#003A63', secondary: '#E51937', text: '#FFFFFF' },
  'Grambling State University': { primary: '#000000', secondary: '#F0AB00', text: '#F0AB00' },
};

// Get colors for a college - falls back to default
export const getCollegeColors = (collegeName) => {
  if (!collegeName) return { primary: '#1a1a1a', secondary: '#16A34A', text: '#16A34A' };
  
  // Direct match
  if (COLLEGE_COLORS[collegeName]) return COLLEGE_COLORS[collegeName];
  
  // Partial match
  const lower = collegeName.toLowerCase();
  for (const [name, colors] of Object.entries(COLLEGE_COLORS)) {
    if (lower.includes(name.toLowerCase().replace('university of ', '').replace(' university', '')) ||
        name.toLowerCase().includes(lower.replace('university of ', '').replace(' university', ''))) {
      return colors;
    }
  }
  
  // Default
  return { primary: '#1a1a1a', secondary: '#16A34A', text: '#16A34A' };
};
